import { render, staticRenderFns } from "./or_treasure_report.vue?vue&type=template&id=da3b44b6&scoped=true"
import script from "./or_treasure_report.vue?vue&type=script&lang=js"
export * from "./or_treasure_report.vue?vue&type=script&lang=js"
import style0 from "./or_treasure_report.vue?vue&type=style&index=0&id=da3b44b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da3b44b6",
  null
  
)

export default component.exports